import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {AlertService, AuthenticationService,} from '../../_services/index';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
    standalone: false,
  selector: 'askString-component',
  templateUrl: 'askString.component.html'
})

export class AskStringComponent {
  formGroup: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<AskStringComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public formBuilder: FormBuilder,
    public alertService: AlertService,
    public authenticationService: AuthenticationService) {
    this.formGroup = formBuilder.group({
      value: [data.initialValue, Validators.required],
    })
  }

  onSave(): void {
    if (this.formGroup.valid) {
      this.dialogRef.close(this.formGroup.value.value);
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
